/* ROLES */
export const GET_BILLS = "GET_BILLS"
export const GET_BILLS_SUCCESS = "GET_BILLS_SUCCESS"
export const GET_BILLS_FAIL = "GET_BILLS_FAIL"

/* ROLES DETAIL*/
export const GET_BILL_DETAIL = "GET_BILL_DETAIL"
export const GET_BILL_DETAIL_SUCCESS = "GET_BILL_DETAIL_SUCCESS"
export const GET_BILL_DETAIL_FAIL = "GET_BILL_DETAIL_FAIL"

/**
 * ADD ROLE
 */
export const ADD_NEW_BILL = "ADD_NEW_BILL"
export const ADD_BILL_SUCCESS = "ADD_BILL_SUCCESS"
export const ADD_BILL_FAIL = "ADD_BILL_FAIL"

/**
 * EDIT ROLE
 */
export const UPDATE_BILL = "UPDATE_BILL"
export const UPDATE_BILL_SUCCESS = "UPDATE_BILL_SUCCESS"
export const UPDATE_BILL_FAIL = "UPDATE_BILL_FAIL"

/**
 * Delete user
 */
export const DELETE_BILL = "DELETE_BILL"
export const DELETE_BILL_SUCCESS = "DELETE_BILL_SUCCESS"
export const DELETE_BILL_FAIL = "DELETE_BILL_FAIL"

/**
 * CLEAR MESSAGE AND ERROR OBJECT
 */
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"

/**
 * EDIT GUEST APPROVED ACCESS
 */
export const UPDATE_BILL_ACCESS = "UPDATE_BILL_ACCESS"
export const UPDATE_BILL_ACCESS_SUCCESS = "UPDATE_BILL_ACCESS_SUCCESS"
export const UPDATE_BILL_ACCESS_FAIL = "UPDATE_BILL_ACCESS_FAIL"

/* BILL ERRORS */
export const GET_BILLS_ERRORS = "GET_BILLS_ERRORS"
export const GET_BILLS_ERRORS_SUCCESS = "GET_BILLS_ERRORS_SUCCESS"
export const GET_BILLS_ERRORS_FAIL = "GET_BILLS_ERRORS_FAIL"
export const CLEAN_BILL_ERRORS = "CLEAN_BILL_ERRORS";

/* BILL FORMATTED ERRORS */
export const GET_BILLS_FORMATTED_ERRORS = "GET_BILLS_FORMATTED_ERRORS"
export const GET_BILLS_FORMATTED_ERRORS_SUCCESS =
  "GET_BILLS_FORMATTED_ERRORS_SUCCESS"
export const GET_BILLS_FORMATTED_ERRORS_FAIL = "GET_BILLS_FORMATTED_ERRORS_FAIL"

/**
 * Export Bills */
export const GET_EXPORT_BILLS = "GET_EXPORT_BILLS"
export const GET_EXPORT_BILLS_SUCCESS = "GET_EXPORT_BILLS_SUCCESS"
export const GET_EXPORTED_BILLS_FAIL = "GET_EXPORTED_BILLS_FAIL"
export const RESET_EXPORT_DATA = "RESET_EXPORT_DATA"

